import kamala from '../../kamala'
import Tree from './Tree'
import TreeNode from './TreeNode'

Tree.install = function (Vue) {
  kamala(Vue)
  Vue.component(Tree.name, Tree)
  Vue.component(TreeNode.name, TreeNode)
}

export default Tree
